<script lang="ts" setup>
    import { inject, computed } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { SegmentAccess } from '../Segments.access';
    import SegmentGroup from './SegmentTypes/SegmentGroup.vue';
    import { setIsNewToFalse, collectIsValid } from './SegmentValidators/utils';
    import Loading from '@shared/components/Loading.vue';
    import { bsAlert, AlertTypes } from '@shared/components/bsAlerts';
    import SegmentsAdd from './SegmentsAdd.vue';
    import { FeatureService } from '@shared/directives/Feature.service';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const segmentAccess: SegmentAccess = injectorAccess.injector.get(SegmentAccess);
    const featureService: FeatureService = injectorAccess.injector.get(FeatureService);

    defineProps<{
        segmentId: string;
    }>();

    const trySubmit = (event: Event) => {
        if (!featureService.hasFeature('Segments')) return;
        if (segmentAccess.state?.segment?.OwnedByJourney != null) return;

        setIsNewToFalse(segmentAccess.state.segment?.SegmentDefinition);
        const isInvalid = collectIsValid(segmentAccess.state.segment?.SegmentDefinition).includes(false);

        isInvalid &&
            bsAlert({
                type: AlertTypes.Danger,
                title: $Resources.GeneralErrorAlertHeading,
                content: $Resources.GeneralErrorAlertBody,
            });

        if (!isInvalid) segmentAccess.save();
    };

    const disableSubmit = computed(() => {
        return segmentAccess.state.loading || segmentAccess.state?.segment?.OwnedByJourney != null || !featureService.hasFeature('Segments');
    });
</script>

<template>
    <Loading :show="segmentAccess.state.loading" loadingStyle="progress-bar" :fixed="true"></Loading>

    <form @submit.prevent="trySubmit">
        <div class="form-group d-flex gap-sm flex-wrap">
            <SegmentsAdd @add="(newVal: string) => segmentAccess.addSegment(newVal)" />

            <span class="m-auto-r"></span>

            <button class="btn btn-primary p-lg-r p-lg-l" type="submit" :disabled="disableSubmit">
                {{ $Resources.SaveBtn }}
            </button>
        </div>

        <div class="m-lg-b">
            <SegmentGroup
                v-if="segmentAccess.state.segment && segmentAccess.state.segment.SegmentDefinition?.DragAndDropId"
                :segment="segmentAccess.state.segment"
                :segment-group="segmentAccess.state.segment.SegmentDefinition"
                :root="true"
                :disallow-root-level-or="segmentAccess.state.segment.OwnedByJourney != null"></SegmentGroup>
        </div>
    </form>
</template>
